import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "variant", "height", "width", "borderRadius", "style"];
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './ghost.module.js';
/**
 * The ghost component
 * @example
 * circle
 * <Ghost borderRadius="50%" height={32} width={32} />
 * Rectangle
 * <Ghost />
 * Pill
 * <Ghost borderRadius={12} height={24} width={100} />
 */

var Ghost = function Ghost(_ref) {
  var className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'pill' : _ref$variant,
      height = _ref.height,
      width = _ref.width,
      borderRadius = _ref.borderRadius,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      rest = _objectWithoutProperties(_ref, _excluded);

  return jsx("span", _objectSpread({
    className: clsx(className, styles.ghost, _defineProperty({}, styles[variant], !!variant)),
    style: _objectSpread({
      height: height,
      width: width,
      borderRadius: borderRadius
    }, style)
  }, rest));
};

Ghost.displayName = 'Ghost';
export { Ghost };